import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatBatchResult } from '../ChatBatchResult'

@InputType()
export class BatchAssignChatsArgs extends ActionArgs {
  @Field(() => [ID])
  chatIds: string[]

  // Nullable — an empty choice unassigns every selected conversation.
  @Field(() => ID, { nullable: true })
  assigneeId?: string
}

export interface IBatchAssignChats extends IAction<ChatBatchResult, BatchAssignChatsArgs> {}
